import { request } from '../utils/request'
import { querystring } from '../utils/index'
export default {
  opensecurityfunc: option => request('v1/securitytag/opensecurityfunc' + querystring(option), option), //  开启防伪码功能
  canclesecurityfunc: option => request('v1/securitytag/canclesecurityfunc' + querystring(option), option), //  取消防伪码功能
  gettagseg4securitys: option => request('v1/securitytag/gettagseg4securitys', option) //  查询防伪码包
}
